module.exports = __webpack_public_path__ + "static/img/matrix-2.aa3ee30.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/business/matrix-2.jpg
// module id = mE0K
// module chunks = 0